// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { karura as _karura } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the karura chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 686
 * Chain Name: Karura
 * Default Block Explorer: https://blockscout.karura.network
 * Default RPC URL: https://eth-rpc-karura.aca-api.network
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { karura } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: karura,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const karura = createCommon({
	..._karura,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
